import React from "react";
import useSnackbar from "hooks/useSnackbar";

const SnackBar = () => {
  const snackbar = useSnackbar();

  return (
    <React.Fragment>
      <div id="snackbar-container">
        {snackbar.messages.map((row, i) => {
          return (
            <div className="snackbar show">
              <p key={i}>{row.message}</p>
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default SnackBar;
